import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { getSendEmailList } from 'actions/sender';

import {
    RaisedButton,
    Table,
    TableRow,
    TableHeader,
    TableHeaderColumn,
    TableRowColumn,
    TableBody,
    IconButton,
    TextField,
} from 'material-ui';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

import styles from 'styles';

class SenderPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            search: '',
        };

        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);

        this.keyPress = this.keyPress.bind(this);
        this.onChange = this.onChange.bind(this);

        this.search = this.search.bind(this);
    }

    search() {
        this.props.getSendEmailList({
            page: 1,
            filters: {
                search: this.state.search,
            }
        });
    }

    keyPress(e) {
        const { search } = this.state;

        if (e.keyCode === 13 && (search.length > 2 || search.length < 40)) {
            this.props.getSendEmailList({
                page: 1,
                filters: { search }
            });
        }
    }

    onChange(e, value) {
        this.setState({
            search: value,
        }, () => {
            if (this.state.search === '') {
                this.props.getSendEmailList({
                    page: 1,
                });
            }
        });
    }

    nextPage() {
        this.props.getSendEmailList({
            page: this.props.senderList.next,
        });
    }

    prevPage() {
        this.props.getSendEmailList({
            page: this.props.senderList.previous || 1,
        });
    }

    UNSAFE_componentWillMount() {
        this.props.getSendEmailList();
    }

    getStatus(status, name) {
        if (!Array.isArray(status)) return 0;
        let count = 0;
        status.forEach((item) => {
            if (item.name === name) count++;
        });
        return count;
    }

    render() {
        const { senderList: { data, page, loading } } = this.props;
        const { search } = this.state;

        return (
            <div id='sender-page' className='table-page'>
                <div className='container'>
                    <h2>Sender email list</h2>

                    <div className='paper-block margin-10'>
                        <div className='row'>
                            <div className='col-xs-2 middle-xs' style={{display: 'flex'}}>
                                <IconButton
                                    iconStyle={styles.navigationLeft}
                                    name='navigationLeft'
                                    onClick={this.prevPage}
                                    disabled={!loading}
                                >
                                    <ChevronLeft />
                                </IconButton>

                                <span>Page: {page}</span>

                                <IconButton
                                    iconStyle={styles.navigationRight}
                                    name='navigationRight'
                                    onClick={this.nextPage}
                                    disabled={!loading}
                                >
                                    <ChevronRight />
                                </IconButton>
                            </div>
                            <div className='col-xs-4 middle-xs' style={{display: 'flex'}}>
                                <TextField
                                    hintText='Search'
                                    value={search}
                                    onChange={this.onChange}
                                    onKeyDown={this.keyPress}
                                />
                                <div style={{ margin: '0 0 0 20px' }}>
                                    <RaisedButton
                                        label='search'
                                        primary
                                        disabled={search.length <= 2 || search.length >= 40}
                                        onClick={this.search}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    info
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    message
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    send
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    open
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    processed
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    delivered
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    click
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    dropped
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    {null}
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>

                        <TableBody displayRowCheckbox={false}>
                            {
                                data.map((item, index) => {
                                    return (<TableRow key={index}>
                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            <p>{item._id}</p>
                                            <p>added - {moment(item.addedAt).format('DD.MM.YYYY')}</p>
                                            <p>updated - {moment(item.updatedAt).format('DD.MM.YYYY')}</p>
                                            <p>category - {item.category}</p>
                                        </TableRowColumn>

                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            <p>to:{item.to}</p>
                                            <p>{item.subject}</p>
                                        </TableRowColumn>

                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { this.getStatus(item.status, 'send') }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { this.getStatus(item.status, 'open') }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { this.getStatus(item.status, 'processed') }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { this.getStatus(item.status, 'delivered') }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { this.getStatus(item.status, 'click') }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { this.getStatus(item.status, 'dropped') }
                                        </TableRowColumn>

                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            <RaisedButton
                                                label='show'
                                                primary
                                                containerElement={
                                                    <Link to={`/sender/${item._id}`} />
                                                }
                                            />
                                        </TableRowColumn>
                                    </TableRow>);
                                })
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ senderList }) => {
        return {
            senderList,
        };
    },
    dispatch => bindActionCreators({
            getSendEmailList,
        },
        dispatch),
)(SenderPage);



// WEBPACK FOOTER //
// ./app/components/Letters/Sender/Page.jsx